<template>
  <v-app >
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  // data() {
  //   return {

  //   }
  // },
  // methods: {
 
  // },
  beforeMount () {
    document.addEventListener('contextmenu', event => event.preventDefault());
  },
};
</script>

<style>
html, #app {
  font-family: 'Source Sans Pro', sans-serif !important;
}

.input-field {
  border-radius: 16px !important;
  height: 56px;
  width: 100%;
  padding: 0 8px;
}

.input-field:focus {
  outline: none !important;
  border: green !important;
}

/* input.focus-visible {
  visibility: hidden !important;
} */

.card {
  background: rgba(255, 255, 255, 0.87) !important;
  box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4), 0px 0px 32px rgba(35, 41, 46, 0.2) !important;
  /* backdrop-filter: blur(24px) !important; */
  border-radius: 32px !important;
  padding: 48px !important;
}

.feature-card {
  padding: 30px !important;
  /* height: 356px !important; */
}

.bottom-card .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  font-size: 17px !important;
  background: rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.5), 0px 6px 16px rgba(35, 41, 46, 0.5) !important;
  color: black !important;
}

::-webkit-scrollbar {
  display: none;
}

.login {
    overflow: hidden !important;
}

.bg-image {
  /* The image used */
  background-image: url('./assets/background.png');
  
  /* Add the blur effect */
  filter: blur(24px);
  /* -webkit-filter: blur(24px); */
  -webkit-filter: blur(0px);
  
  /* Full height */
  height: 100vh; 
  
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.login-area {
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(1, 220, 252, 0.6); /* Black w/
  background-color: rgba(12, 204, 166, 0.6); /* Black w/opacity/see-through */
  color: white;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 100%;
  height: 100vh;
  padding: 20px;
  text-align: center;
}

.section {
    position: absolute;
    top: 40%;
    width: 446px;
    height: 232px;
    left: 50%;
    transform: translate(-50%, -50%);
}

.fullscreen-dialog {
  background-image: url('./assets/background.png') !important;
  box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4),
    0px 0px 32px rgba(35, 41, 46, 0.2) !important;
  backdrop-filter: blur(24px) !important;
  border-radius: 0 !important;
}
</style>



